import { mountStandaloneApp } from '@yuksalish/ui'
import { procurementMessages } from './i18n'
import './styles.css'
import OverviewPage from './pages/OverviewPage.vue'
import PurchaseOrdersPage from './pages/PurchaseOrdersPage.vue'
import PurchaseOrderDetailPage from './pages/PurchaseOrderDetailPage.vue'
import PurchaseOrderFormPage from './pages/PurchaseOrderFormPage.vue'
import SuppliersPage from './pages/SuppliersPage.vue'
import DeliveriesPage from './pages/DeliveriesPage.vue'
import SupplierInvoicesPage from './pages/SupplierInvoicesPage.vue'
import SupplierInvoiceFormPage from './pages/SupplierInvoiceFormPage.vue'
import SupplierInvoiceDetailPage from './pages/SupplierInvoiceDetailPage.vue'

const view = 'purchase_orders.view'
const create = 'purchase_orders.create'
const update = 'purchase_orders.update'
const invoiceView = 'supplier_invoices.view'
const invoiceCreate = 'supplier_invoices.create'
const invoiceUpdate = 'supplier_invoices.update'

type NavKey = keyof typeof procurementMessages.en.procurement.nav

function nav(key: NavKey) {
  return {
    en: procurementMessages.en.procurement.nav[key],
    ru: procurementMessages.ru.procurement.nav[key],
    uz: procurementMessages.uz.procurement.nav[key],
  }
}

mountStandaloneApp({
  code: 'procurement',
  title: 'Procurement',
  description: 'Purchase orders, suppliers and delivery tracking.',
  accent: '#765a30',
  messages: procurementMessages,
  requiredPermissions: [view],
  navigation: [
    { label: nav('overview'), to: '/overview', permission: view },
    {
      label: nav('purchasing'),
      to: '/purchase-orders',
      permission: view,
      children: [
        { label: nav('purchaseOrders'), to: '/purchase-orders', permission: view },
        { label: nav('deliveries'), to: '/deliveries', permission: view },
      ],
    },
    { label: nav('suppliers'), to: '/suppliers', permission: view },
    { label: nav('invoices'), to: '/supplier-invoices', permission: invoiceView },
  ],
  routes: [
    { path: '', redirect: '/overview' },
    { path: 'overview', component: OverviewPage, meta: { permission: view } },
    { path: 'purchase-orders', component: PurchaseOrdersPage, meta: { permission: view } },
    { path: 'purchase-orders/new', component: PurchaseOrderFormPage, meta: { permission: create } },
    { path: 'purchase-orders/:id/edit', component: PurchaseOrderFormPage, meta: { permission: update } },
    { path: 'purchase-orders/:id', component: PurchaseOrderDetailPage, meta: { permission: view } },
    { path: 'suppliers', component: SuppliersPage, meta: { permission: view } },
    { path: 'deliveries', component: DeliveriesPage, meta: { permission: view } },
    { path: 'supplier-invoices', component: SupplierInvoicesPage, meta: { permission: invoiceView } },
    { path: 'supplier-invoices/new', component: SupplierInvoiceFormPage, meta: { permission: invoiceCreate } },
    { path: 'supplier-invoices/:id/edit', component: SupplierInvoiceFormPage, meta: { permission: invoiceUpdate } },
    { path: 'supplier-invoices/:id', component: SupplierInvoiceDetailPage, meta: { permission: invoiceView } },
  ],
})
